import { RootState } from '@/store'

// select participant id
export const selectConversationParticipantId = (state: RootState) =>
  state.chat.conversation.data.data?.participant?.id

// select chat id
export const selectConversationChatId = (state: RootState) => state.chat.conversation.data.data?.id
